// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconBrandChrome, IconHelp, IconSitemap, IconPackage, IconCoin, IconAnalyze, IconReportSearch } from '@tabler/icons';

// constant
const icons = {
    IconBrandChrome,
    IconHelp,
    IconSitemap,
    IconPackage,
    IconCoin,
    IconAnalyze,
    IconReportSearch
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const process = {
    id: 'sample-docs-roadmap',
    type: 'group',
    title: <FormattedMessage id="process" />,
    children: [
        {
            id: 'process/inventory',
            title: <FormattedMessage id="Inventory" />,
            type: 'item',
            url: '/process/inventory',
            icon: icons.IconPackage,
            breadcrumbs: false
        },
        {
            id: 'process/prices',
            title: <FormattedMessage id="Prices" />,
            type: 'item',
            url: '/process/prices',
            icon: icons.IconCoin,
            breadcrumbs: false
        },
        {
            id: 'stateMachines',
            title: <FormattedMessage id="stateMachines" />,
            type: 'item',
            url: '/stateMachines',
            icon: icons.IconAnalyze,
            breadcrumbs: false
        },
        {
            id: 'logsPage',
            title: 'History',
            type: 'item',
            url: '/history',
            icon: icons.IconReportSearch,
            breadcrumbs: false
        }
    ]
};

export default process;
